var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SortedItem"},[_c('MnemonicImage',{staticClass:"image",attrs:{"image":_vm.image}}),_c('div',{staticClass:"checkmark"},[_c('svgicon',{attrs:{"icon":"checkmark"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }